import type {
  CoreBookingStatus,
  CoreBookingPaymentRentalStatus,
  CoreBookingPaymentDepositStatus,
  CoreBookingResponse,
} from '@flecto/types'

import { api } from '../../../services/api'

/**
 * Get all user logged bookings.
 *
 * @endpoint GET /api/saas/me/bookings
 * @scope saas
 * @see https://flecto.dev/api-4724142
 */

export async function getAllBookings(
  options?: GetAllBookingOptions
): Promise<CoreBookingResponse> {
  const response = await api.get<CoreBookingResponse>('/api/saas/me/bookings', {
    params: options,
  })

  return response.data
}

export type GetAllBookingOptions = {
  q?: string
  limit?: number
  offset?: number
  order?: 'asc' | 'desc'
  sort?: 'id' | 'start_at' | 'customer_name'
  from?: string
  to?: string
  status?: CoreBookingStatus[]
  customer_ids?: number[]
  item_ids?: number[]
  payment_rental_status?: CoreBookingPaymentRentalStatus[]
  payment_deposit_status?: CoreBookingPaymentDepositStatus[]
}
